import React, { FC } from 'react'
import { Headline } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { ScheduleType } from 'types/schedule'
import {
  CardGreyHeadline,
  CardOutlined,
  CardOutlinedInner,
  DefaultStocksDetailCard,
  HoursToDeadlineDetailCard,
} from 'components/Card'
import HTMLReactParser from 'html-react-parser'
import { returnCodeToBr } from 'lib/helper'
import { StockUnionType } from 'types/stock'

type Props = {
  schedules: ScheduleType[]
  type: StockUnionType
}

const ScheduleSettings: FC<Props> = (props) => {
  const { schedules, type } = props
  const schedule = schedules[0]
  if (!schedule) return <></>
  const maximumOrder = schedule ? `${schedule.maximum_order}個` : ''
  const note = schedule ? HTMLReactParser(returnCodeToBr(schedule.note)) : ''
  return (
    <>
      {type === 'daily' && <Headline headline={'当日取り置きの設定'} />}
      {type === 'preorder' && <Headline headline={'事前予約日の設定'} />}
      <Spacer size={20} />
      <CardOutlined>
        {type === 'daily' && <CardGreyHeadline headline={'受渡解禁時刻とオープン時在庫数'} isTop={true} />}
        {type === 'preorder' && <CardGreyHeadline headline={'受渡解禁時刻と1日の販売上限数'} isTop={true} />}
        <Spacer size={8} />
        <CardOutlinedInner>
          {schedules.map((schedule) => (
            <React.Fragment key={schedule.schedule_ref?.id}>
              <DefaultStocksDetailCard schedule={schedule} type={type} />
              <Spacer size={8} />
            </React.Fragment>
          ))}
        </CardOutlinedInner>
        <CardGreyHeadline headline={'注文締め切り'} />
        <Spacer size={8} />
        <CardOutlinedInner>
          {type !== 'daily' &&
            schedules.map((schedule) => (
              <React.Fragment key={schedule.schedule_ref?.id}>
                <HoursToDeadlineDetailCard key={schedule.schedule_ref?.id} schedule={schedule} />
                <Spacer size={8} />
              </React.Fragment>
            ))}
        </CardOutlinedInner>
        <CardGreyHeadline headline={'おひとりさま購入上限数'} />
        <Spacer size={8} />
        <CardOutlinedInner>{maximumOrder}</CardOutlinedInner>
        <Spacer size={8} />
        {/* 受渡オプションが指定されている場合 */}
        {schedule.choices.length > 0 && (
          <>
            <CardGreyHeadline headline={'商品の受渡しオプション'} />
            <Spacer size={8} />
            <CardOutlinedInner>
              {schedule.choices.map((choice, index) => (
                <React.Fragment key={choice}>
                  <span>{choice}</span>
                  {index + 1 !== schedule.choices.length && <br />}
                </React.Fragment>
              ))}
            </CardOutlinedInner>
            <Spacer size={8} />
          </>
        )}
        {schedule.note !== '' && (
          <>
            <CardGreyHeadline headline={'商品受渡し時の注意点'} />
            <Spacer size={8} />
            <CardOutlinedInner>{note}</CardOutlinedInner>
            <Spacer size={8} />
          </>
        )}
      </CardOutlined>
    </>
  )
}

export default ScheduleSettings
